import { render, staticRenderFns } from "./kafpos-form-confirmation.vue?vue&type=template&id=10008756&scoped=true&lang=pug"
import script from "./kafpos-form-confirmation.vue?vue&type=script&setup=true&lang=js"
export * from "./kafpos-form-confirmation.vue?vue&type=script&setup=true&lang=js"
import style0 from "./kafpos-form-confirmation.vue?vue&type=style&index=0&id=10008756&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10008756",
  null
  
)

export default component.exports